var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.67,
    height: 24,
    fill: "#0055A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    width: 10.67,
    height: 24,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.33,
    width: 10.67,
    height: 24,
    fill: "#EF4135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfFrance);
export default __webpack_public_path__ + "static/media/Flag_of_France.fbdb7f645cbb55e17915ef0546355f87.svg";
export { ForwardRef as ReactComponent };